import { JobStatusType, ProductCategory, TimesheetType } from '@/enum'
import { generateIterableListFromEnum } from '../helpers'
import { JobStatusTypeLabel } from '@/enum/JobStatusType'
import { TimesheetTypeLabel } from '@/enum/TimesheetType'
import { ProductCategoryLabel } from '@/enum/ProductCategory'

const {
  VITE_WEB_CLIENT_TYPE,
  VITE_MOBILE_CLIENT_TYPE,
  VITE_API_URL,
  VITE_DEFAULT_PAGING_LIMIT,
  VITE_APPNAME,
  VITE_ASSETS_PREFIX,
  VITE_ENV,
  VITE_APP_VERSION,
  VITE_SENTRY_DSN,
  VITE_SENTRY_AUTH_TOKEN,
} = import.meta.env

export const DASHBOARD_DOMAINS = {
  DEVELOPMENT: { URL: 'https://web-dev.awsm-app.co.uk/', ENV_NAME: 'Development' },
  STAGING: { URL: 'https://web-staging.awsm-app.co.uk/', ENV_NAME: 'Staging' },
  DEMO: { URL: 'https://web-demo.awsm-app.co.uk', ENV_NAME: 'Demo' },
  PRODUCTION: { URL: '', ENV_NAME: 'Production' }
}

export const APP_ENV = VITE_ENV
export const APP_VERSION = VITE_APP_VERSION
export const DASHBOARD_CLIENT_TYPE = VITE_WEB_CLIENT_TYPE
export const MOBILE_CLIENT_TYPE = VITE_MOBILE_CLIENT_TYPE
export const BASE_URL = '/'
export const BASE_API_URL = VITE_API_URL
export const APP_NAME = 'AWSM'
export const APP_ASSETS_PREFIX = VITE_ASSETS_PREFIX
export const DEFAULT_LIST_EXPORT_FORMAT = 'csv'
export const DISABLE_SUBMIT_BUTTON_TIMEOUT_IN_SECONDS = 30

export const LOGIN_URL = '/login'
export const LOGIN_URL_NAME = 'Login'
export const RESET_PASSWORD_URL = '/reset'
export const RESET_PASSWORD_URL_NAME = 'Reset Password'
export const SET_PASSWORD_URL = '/set-password'
export const SET_PASSWORD_URL_NAME = 'Set Password'
export const REVOKE_URL = 'revoke'
export const ADD_URL = `add`
export const HISTORY_URL = `history`
export const INSPECTIONS_URL = `inspections`
export const IMPORT_URL = `import`
export const IMPORT_TEMPLATE_URL = `import-template`
export const FUEL_ENTRIES_URL = `fuel-entries`
export const FUEL_ENTRIES_URL_NAME = 'Fuel Entries'
export const DEF_ENTRIES_URL = `ad-blue-entries`
export const DEF_ENTRIES_URL_NAME = 'AdBlue Entries'

export const HOME_URL = '/'
export const HOME_URL_NAME = 'Overview'

export const ERRORS_URL = '/errors'
export const ERRORS_URL_NAME = 'Errors'

export const EMPLOYEES_URL = '/employees'
export const EMPLOYEES_URL_NAME = 'Employees'
export const EMPLOYEES_ADD_URL_NAME = 'Add Employee'
export const EMPLOYEES_LIST_URL_NAME = 'Employees List'
export const EMPLOYEES_EDIT_URL = `edit`
export const EMPLOYEES_EDIT_URL_NAME = 'Edit Employee'

export const CUSTOMERS_URL = '/customers'
export const CUSTOMERS_URL_NAME = 'Customers'
export const CUSTOMERS_ADD_URL_NAME = 'Add Customer'
export const CUSTOMERS_LIST_URL_NAME = 'Customers List'
export const CUSTOMERS_EDIT_URL = `edit`
export const CUSTOMERS_EDIT_URL_NAME = 'Edit Customer'

export const TRAILERS_URL = '/trailers'
export const TRAILERS_URL_NAME = 'Trailers'
export const TRAILERS_ADD_URL_NAME = 'Add New Trailer'
export const TRAILERS_LIST_URL_NAME = 'Trailers List'
export const TRAILERS_EDIT_URL = `edit`
export const TRAILERS_EDIT_URL_NAME = 'Edit Trailer'

export const FIELDS_URL = '/fields'
export const FIELDS_URL_NAME = 'Fields'
export const FIELDS_ADD_URL_NAME = 'Add Field'
export const FIELDS_LIST_URL_NAME = 'Fields List'
export const FIELDS_EDIT_URL = `edit`
export const FIELDS_EDIT_URL_NAME = 'Edit Field'

export const PRODUCTS_URL = '/products'
export const PRODUCTS_URL_NAME = 'Products'
export const PRODUCTS_ADD_URL_NAME = 'Add Products'
export const PRODUCTS_LIST_URL_NAME = 'Products List'
export const PRODUCTS_EDIT_URL = `edit`
export const PRODUCTS_EDIT_URL_NAME = `Edit Product`

export const SILOS_URL = '/stores'
export const SILOS_URL_NAME = 'Stores'
export const SILOS_ADD_URL_NAME = 'Add Store'
export const SILOS_LIST_URL_NAME = 'Stores List'
export const SILOS_EDIT_URL = `edit`
export const SILOS_EDIT_URL_NAME = `Edit Store`
export const SILOS_HISTORY_URL_NAME = `Stores History`
export const SILOS_INSPECTIONS_URL_NAME = `Stores Inspections`

export const VEHICLES_URL = '/vehicles'
export const VEHICLES_URL_NAME = 'Vehicles'
export const VEHICLES_ADD_URL_NAME = 'Add Vehicle'
export const VEHICLES_LIST_URL_NAME = 'Vehicles List'
export const VEHICLES_EDIT_URL = `edit`
export const VEHICLES_EDIT_URL_NAME = 'Edit Vehicle'
export const VEHICLES_INSPCETIONS_LIST_URL = `edit`
export const VEHICLES_INSPECTIONS_LIST_URL_NAME = `Vehicle Inspections`

export const FARMS_URL = '/farms'
export const FARMS_URL_NAME = 'Farms'
export const FARMS_ADD_URL_NAME = 'Add Farm'
export const FARMS_LIST_URL_NAME = 'Farms List'
export const FARMS_EDIT_URL = `edit`
export const FARMS_EDIT_URL_NAME = 'Edit Farm'

export const SERVICES_URL = '/waste-collection-providers'
export const SERVICES_URL_NAME = 'Waste Collection Services'
export const SERVICES_ADD_URL_NAME = 'Add Waste Collection Service'
export const SERVICES_LIST_URL_NAME = 'Waste Collection Services List'
export const SERVICES_EDIT_URL = `edit`
export const SERVICES_EDIT_URL_NAME = `Edit Waste Collection Service`

export const WASTE_DELIVERY_SITES_URL = '/waste-delivery-sites'
export const WASTE_DELIVERY_SITES_URL_NAME = 'Waste Delivery Sites'
export const WASTE_DELIVERY_SITES_ADD_URL_NAME = 'Add Waste Delivery Site'
export const WASTE_DELIVERY_SITES_LIST_URL_NAME = 'Waste Delivery Sites List'
export const WASTE_DELIVERY_SITES_EDIT_URL = 'edit'
export const WASTE_DELIVERY_SITES_EDIT_URL_NAME = 'Edit Waste Delivery Site'

export const DELIVERY_SITES_URL = '/ad-plant-sites'
export const DELIVERY_SITES_URL_NAME = 'AD Plant Sites'
export const DELIVERY_SITES_ADD_URL_NAME = 'Add AD Plant Site'
export const DELIVERY_SITES_LIST_URL_NAME = 'AD Plant Sites List'
export const DELIVERY_SITES_EDIT_URL = 'edit'
export const DELIVERY_SITES_EDIT_URL_NAME = 'Edit AD Plant Site'

export const SPREADING_JOBS_URL = '/spreading-jobs'
export const SPREADING_JOBS_URL_NAME = 'Spreading Jobs'
export const SPREADING_JOBS_LIST_URL_NAME = 'Spreading Jobs List'
export const SPREADING_JOBS_ADD_URL_NAME = 'Add Spreading Job'
export const SPREADING_JOBS_DETAILS_URL_NAME = 'Spreading Job Details'
export const SPREADING_JOBS_EDIT_JOB_URL = `edit`
export const SPREADING_JOBS_EDIT_JOB_URL_NAME = `Edit Spreading Job`

export const HAULAGE_JOBS_BASE_URL = '/transport-job/haulage-jobs'
export const HAULAGE_JOBS_URL = 'haulage-jobs'
export const HAULAGE_JOBS_URL_NAME = 'Transport Jobs Haulage'
export const HAULAGE_JOBS_ADD_URL_NAME = 'Add Haulage Job'
export const HAULAGE_JOBS_LIST_URL_NAME = 'Haulage Jobs'
export const HAULAGE_JOBS_SCHEDULE_JOB_URL = `schedule-job`
export const HAULAGE_JOBS_SCHEDULE_JOB_URL_NAME = `Schedule Haulage Job`
export const HAULAGE_JOBS_DETAILS_URL_NAME = 'Haulage Job Details'
export const HAULAGE_JOBS_EDIT_JOB_URL = `edit`
export const HAULAGE_JOBS_EDIT_JOB_URL_NAME = `Edit Haulage Job`

export const DIGESTATE_JOBS_BASE_URL = '/transport-job/digestate-jobs'
export const DIGESTATE_JOBS_URL = 'digestate-jobs'
export const DIGESTATE_JOBS_URL_NAME = 'Transport Jobs Digestate'
export const DIGESTATE_JOBS_ADD_URL_NAME = 'Add Digestate Job'
export const DIGESTATE_JOBS_LIST_URL_NAME = 'Digestate Jobs'
export const DIGESTATE_JOBS_SCHEDULE_JOB_URL = `schedule-job`
export const DIGESTATE_JOBS_DETAILS_URL_NAME = 'Digestate Job Details'
export const DIGESTATE_JOBS_SCHEDULE_JOB_URL_NAME = `Schedule Digestate Job`
export const DIGESTATE_JOBS_EDIT_JOB_URL = `edit`
export const DIGESTATE_JOBS_EDIT_JOB_URL_NAME = `Edit Digestate Job`

export const TRANSPORT_JOBS_URL = '/transport-job'
export const TRANSPORT_JOBS_URL_NAME = 'Transport Jobs'

export const COLLECTION_SITES_URL = '/waste-collection-sites'
export const COLLECTION_SITES_URL_NAME = 'Waste Collection Sites'
export const COLLECTION_SITES_ADD_URL_NAME = 'Add Waste Collection Site'
export const COLLECTION_SITES_LIST_URL_NAME = 'Waste Collection Sites List'
export const COLLECTION_SITES_EDIT_URL = `edit`
export const COLLECTION_SITES_EDIT_URL_NAME = `Edit Waste Collection Site`

export const TIME_SHEETS_URL = '/timesheets'
export const TIME_SHEETS_URL_NAME = 'Timesheets'
export const TIME_SHEETS_LIST_URL_NAME = 'Timesheets List'
export const TIME_SHEETS_ADD_URL_NAME = 'Add TimeSheet'
export const TIMESHEET_EDIT_URL = `edit`
export const TIMESHEET_EDIT_URL_NAME = `Edit Timesheet`

export const ACCOUNT_URL = '/account'
export const ACCOUNT_HTTP = '/account/http'

export const ACTIVITIES_URL = `/activities`
export const CONFIG_URL = `/config`

export const USERS_URL_NAME = 'Users'
export const NOTIFICATIONS_NAME = 'Notifications'
export const DEFAULT_PAGE_OFFSET = 0
export const DEFAULT_PAGE_LIMIT = +VITE_DEFAULT_PAGING_LIMIT
export const CANCELED_REQUEST_CODE = 'ERR_CANCELED'
export const NETWORK_ERROR_CODE = 'ERR_NETWORK'
export const CANCELLED_REQUEST_STATUS = 0
export const NUMBER_OF_MILLISECONDS_IN_DAY = 86400000
export const DEFAULT_TIMEOUT_BUFFER = 500
export const DEFAULT_DISTANCE_UNIT = 'miles'
export const DEFAULT_COOKIE_MAX_AGE = 60 * 60 * 24 * 365
export const HOURS_IN_DAY = 24
export const MINUTES_IN_HOUR = 60
export const DEFAULT_MAXIMUM_DAYS_IN_DATE_RANGE = 90
export const MAX_FILE_SIZE = 25
export const WORKER_SIGNAL_R = 'signalRWorker'
export const GLOBAL_ERROR_TYPES = {
  COMPONENT: 'Component Error',
  NETWORK: 'Network Error',
  FILE: 'File Error',
  UNKNOWN: 'Unknown Error'
}
export const DEFAULT_JOB_START_TIME = '00:00'
export const DEFAULT_JOB_END_TIME = '23:59'
export const DEFAULT_TIMESHEET_START_TIME = '08:00'
export const DEFAULT_TIMESHEET_END_TIME = '18:00'

//sentry
export const SENTRY_DSN_KEY = VITE_SENTRY_DSN
export const SENTRY_AUTH_KEY = VITE_SENTRY_AUTH_TOKEN
export const SENTRY_TRACES_SAMPLE_RATE = 1.0
export const SENTRY_REPLAYS_SESSION_SAMPLE_RATE = (VITE_ENV == 'Production') ? 0.5 : 1.0
export const SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE = 1.0

export const JOB_STATUS_TYPES = (() =>
  generateIterableListFromEnum(JobStatusType, JobStatusTypeLabel))()

export const TIMESHEET_TYPES = (() =>
  generateIterableListFromEnum(TimesheetType, TimesheetTypeLabel))()

export const PRODUCT_CATEGORY = (() =>
  generateIterableListFromEnum(ProductCategory, ProductCategoryLabel))()
